import { defineStore } from 'pinia';

import { ApiGetDashboards } from '@/api/team.js';

export const routerStore = defineStore({
  id: 'route',
  state: () => {
    return {
      dashboardList: []
    };
  },
  getters: {
    router() {
      return this.$router;
    },
    route() {
      return this.$route;
    },
    allRoute() {
      return this.$router?.options?.routes[0]?.children;
    },
    tabLists(state) {
      const result = state.allRoute.map((item) => ({
        name: item.name,
        value: item.meta.key,
        child: item.children
      }));

      return result || [];
    },
    tabsPermission(state) {
      let result = {};
      state.allRoute.forEach((mother) => {
        result[mother.meta.key] = [];
        mother?.children?.forEach((child) => {
          if (child.meta.permission) {
            result[mother.meta.key].push(child.meta.permission);
          }
          if (child?.children) {
            child?.children.forEach((child2) => {
              if (child2.meta.permission) {
                result[mother.meta.key].push(child2.meta.permission);
              }
            });
          }
        });
      });

      return result || {};
    },
    currentRoute() {
      return this.$router?.currentRoute;
    },
    dashboardMap() {
      return this.dashboardList.map((item) => ({
        href: '/data-overview/dashboard/' + item.uuid,
        title: item.name
      }));
    },
    dashboardTitleMap() {
      let result = {};
      this.dashboardList.forEach((item) => {
        result[item.uuid] = item.name;
      });
      return result;
    }
  },
  actions: {
    async getDashboard() {
      const data = await ApiGetDashboards();
      if (!data.msg) {
        this.dashboardList = data?.results;
      }
    },
    setDashboardTitle({ uuid, name }) {
      this.dashboardList.forEach((item) => {
        if (item.uuid === uuid) {
          item.name = name;
        }
      });
    }
  }
});
